/**
 * Temporal bridge for StartOptions → auth module init.
 * server.ts sets the hook; auth/init() consumes and clears it.
 */
import type { TokenCreateHook } from '@kernel/config/types.js'

let _pending: TokenCreateHook | undefined

export function setTokenCreateHook(fn: TokenCreateHook | undefined): void {
  _pending = fn
}

export function consumeTokenCreateHook(): TokenCreateHook | undefined {
  const fn = _pending
  _pending = undefined
  return fn
}
